










































































































import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { IHeightStyle } from "@/@types/styles/height";
import draggable from "vuedraggable";
import { IPageConfig } from "@/@types/filoxenia-config/nav-bar";

@Component({ components: { draggable } })
export default class HotelConfigurationDemo extends Vue {
  @Inject({ from: "backgroundFolder", default: null })
  readonly backgroundFolder!: string;
  @Prop({ type: String, default: "" }) background!: string;
  @Prop({ type: Array, default: () => [] }) navMain!: Array<IPageConfig>;
  @Prop({ type: Array, default: () => [] }) navLight!: Array<IPageConfig>;

  show = false;
  enabled = true;
  dragging = false;
  iconfolder = "main/configuration/icons";

  mainHeight: IHeightStyle = {
    minHeight: "auto",
    maxHeight: "auto",
  };

  get backgroundImage(): string | null {
    if (!this.background) return null;
    return `${this.$getWebImage(this.background, this.backgroundFolder)}`;
  }

  calculateHeight(): void {
    this.mainHeight.maxHeight = sessionStorage.getItem("demo-height") + "px";
    this.mainHeight.minHeight = sessionStorage.getItem("demo-height") + "px";
    this.show = true;
  }

  mounted(): void {
    this.$nextTick(() => this.calculateHeight());
  }
}
